jQuery(document).ready(function($) {
	$('#categories, #tags').on('change', function () {
		var url = $(this).val();
		if (url) {
			if (url == 'all') {
				window.location = $(this).data('default');
			} else {
				window.location = url;
			}
		}
		return false;
	});

	// Content Table Functionality
	let links = $('.blog-anchors').data('links');

	if (!links) { 
		links = 3; 
	}

	var i = 1;

	$('.article-content').find('h1, h2, h3').each(function(index) {
		i++;
		var header_text = $(this).text().replace(/[^a-zA-Z0-9 ]/g, "");
		let anchorLink = $(this).text().toLowerCase().split(' ').join('-') + '-' + index;

		$(this).addClass('anchor').attr("id", anchorLink);

		if (i <= links) {
			$('#table-of-contents').append('<li class="' + anchorLink + '" style="display: block"><a href="#' + anchorLink + '">' + header_text + '</a></li>');
		} else {
			$('#table-of-contents').append('<li class="' + anchorLink + '"><a href="#' + anchorLink + '">' + header_text + '</a></li>');
		}
	});

	if (i > links) {
		$('.blog-anchors ul').append('<li class="anchor-more" style="display: block"><a href="#">&plus; More</a></li><li class="anchor-less"><a href="#">&minus; Less</a></li>');
	}

	$('.anchor-more').click(function(event) {
		event.preventDefault();
		$(this).hide();
		$(this).parent().addClass('show-all');
		$(this).parent().find('.anchor-less').show();
	});

	$('.anchor-less').click(function(event) {
		event.preventDefault();
		$(this).hide();
		$(this).parent().removeClass('show-all');
		$(this).parent().find('.anchor-more').show();
	});
});